import React from "react";
import { motion } from "framer-motion";
import { FaHtml5, FaReact, FaNodeJs, FaAws, FaDatabase, FaPython, FaDocker, FaGitAlt, FaCode, FaChartLine } from "react-icons/fa";
import { SiFirebase, SiGraphql, SiKubernetes, SiTensorflow, SiNextdotjs, SiTypescript, SiJest, SiRedux } from "react-icons/si";
import { AiOutlineMobile, AiOutlineCloudServer, AiOutlineSecurityScan } from "react-icons/ai";
import "./WebDesignPage.css";

import SampleImage1 from "./2.jpg";
import SampleImage2 from "./155.png";
import SampleImage3 from "./3.webp";


const WebDesignPage = () => {
  return (
    <div className="web-design-container">
      {/* Gradient Background Animation */}
      <div className="gradient-background"></div>

      {/* Hero Section */}
      <section className="hero-section">
        <motion.div
          className="hero-video-wrapper"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <video autoPlay loop muted className="hero-video">
            <source src="videos/7.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <motion.h1
            className="hero-title"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 1 }}
          >
            Crafting Digital Experiences That Inspire 🚀
          </motion.h1>
          <motion.p
            className="hero-subtitle"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 1 }}
          >
            We build scalable, modern, and user-centric web solutions.
          </motion.p>
        </motion.div>
      </section>

      <section className="responsive-design-section">
    <motion.h2
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
    >
        Innovative Software Solutions: Intuitive, Scalable, and Cutting-Edge 🌐✨
    </motion.h2>
    <blockquote className="responsive-quote">
        "Empowering businesses with technology that drives growth 💡"
    </blockquote>
    <motion.div
        className="responsive-description-wrapper"
        initial={{ x: -100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
    >
        At <b>Codeprowl Technologies</b>, we specialize in delivering innovative software solutions tailored to meet the unique needs of modern businesses. As a leading software company, we combine creativity and technical expertise to build scalable, responsive, and high-performance applications that drive efficiency and growth.
        <p>
            Our team of skilled developers and designers is committed to creating software that not only looks exceptional but also delivers seamless functionality across all platforms. From custom software development to enterprise solutions, we ensure our products are optimized for performance, security, and user experience.
        </p>
        <p>
            <strong>Why Choose Codeprowl Technologies?</strong>
            <ul>
                <li>✅ Expertise in developing scalable and future-ready software solutions.</li>
                <li>✅ A dedicated team of experienced developers, designers, and QA engineers.</li>
                <li>✅ Timely delivery and cost-effective solutions tailored to your business needs.</li>
            </ul>
        </p>
    </motion.div>
</section>
      {/* Horizontal Value Design Section */}
      <section className="value-design-section">
        <motion.h2
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          Our Achievements in Numbers 📊
        </motion.h2>
        <motion.div
          className="value-grid"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="value-item">
            <h3>100+</h3>
            <p>Projects Completed</p>
          </div>
          <div className="value-item">
            <h3>95%</h3>
            <p>Client Satisfaction</p>
          </div>
          <div className="value-item">
            <h3>2+</h3>
            <p>Years of Experience</p>
          </div>
          <div className="value-item">
            <h3>50+</h3>
            <p>Global Clients</p>
          </div>
        </motion.div>
      </section>

      {/* Web Design Services Section */}
      <section className="services-design-section">
        <motion.h2
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          Web Design Services at Your Fingertips! 🖥️
        </motion.h2>
        <blockquote className="services-quote">
          "The website developed today is the technical challenge for eternity 🔧"
        </blockquote>
        <motion.div
          className="services-description-wrapper"
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          At Websitica, we specialize in creating designs that are not only visually appealing but are also technically sound and easy to manage.<br /> Our services include:
          <ul className="services-list">
            <li><AiOutlineMobile size={25} /> Responsive Web Designs 🌍</li>
            <li><FaReact size={25} /> Great User Experience (UX) Designs 😍</li>
            <li><FaHtml5 size={25} /> Professional, Mobile-Friendly Designs 📱</li>
            <li><FaNodeJs size={25} /> Custom Designs Tailored to Your Business Needs 💼</li>
            <li><AiOutlineCloudServer size={25} /> Cloud-Based Solutions ☁️</li>
            <li><FaPython size={25} /> AI & Machine Learning Integration 🤖</li>
            <li><AiOutlineSecurityScan size={25} /> Secure Web Applications 🔒</li>
            <li><FaChartLine size={25} /> Analytics-Driven Design Optimization 📊</li>
          </ul>
          <p className="services-satisfaction-text">
            Experience 100% satisfaction with our web development services! 🎉
          </p>
        </motion.div>
      </section>

      {/* Portfolio Showcase Section */}
      <section className="portfolio-section">
        <motion.h2
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          Our Demoe list 🎨
        </motion.h2>
        <motion.div
          className="portfolio-wrapper"
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <p>Check out some of our recent projects:</p>
          <div className="portfolio-grid">
            <div className="portfolio-item">
              <img src={SampleImage1} alt="Sample Project 1" />
              <h3>E-Commerce Website</h3>
              <p>A fully responsive e-commerce platform with seamless payment integration.</p>
            </div>
            <div className="portfolio-item">
              <img src={SampleImage2} alt="Sample Project 2" />
              <h3>Corporate Website</h3>
              <p>A modern corporate website with advanced analytics and SEO optimization.</p>
            </div>
            <div className="portfolio-item">
              <img src={SampleImage3} alt="Sample Project 3" />
              <h3>Portfolio Website</h3>
              <p>A sleek portfolio website showcasing creative work and achievements.</p>
            </div>
          </div>
        </motion.div>
      </section>

      {/* New Technologies Used Section */}
      <section className="technologies-used-section">
        <motion.h2
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          Technologies We Use 🛠️
        </motion.h2>
        <motion.div
          className="technologies-wrapper"
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <p>We leverage modern and powerful technologies to deliver exceptional results:</p>
          <ul className="technologies-list">
            <li>
              <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }} className="technology-item">
                <FaReact size={40} /> <strong>React JS</strong> - Building dynamic, interactive UIs ⚛️
              </motion.div>
            </li>
            <li>
              <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }} className="technology-item">
                <SiNextdotjs size={40} /> <strong>Next.js</strong> - Server-side rendering and static site generation 🌐
              </motion.div>
            </li>
            <li>
              <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }} className="technology-item">
                <FaNodeJs size={40} /> <strong>Node JS</strong> - Backend development with non-blocking, event-driven architecture 🌐
              </motion.div>
            </li>
            <li>
              <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }} className="technology-item">
                <FaAws size={40} /> <strong>AWS</strong> - Scalable cloud services for hosting and management ☁️
              </motion.div>
            </li>
            <li>
              <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }} className="technology-item">
                <SiFirebase size={40} /> <strong>Firebase</strong> - Real-time database, authentication, and cloud services 🔥
              </motion.div>
            </li>
            <li>
              <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }} className="technology-item">
                <FaDatabase size={40} /> <strong>SQL</strong> - Relational database management for structured data 🗄️
              </motion.div>
            </li>
            <li>
              <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }} className="technology-item">
                <SiGraphql size={40} /> <strong>GraphQL</strong> - Efficient API querying and data fetching 📊
              </motion.div>
            </li>
            <li>
              <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }} className="technology-item">
                <FaDocker size={40} /> <strong>Docker</strong> - Containerization for consistent deployments 🐳
              </motion.div>
            </li>
            <li>
              <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }} className="technology-item">
                <SiKubernetes size={40} /> <strong>Kubernetes</strong> - Orchestrating containerized applications 🚢
              </motion.div>
            </li>
            <li>
              <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }} className="technology-item">
                <SiTensorflow size={40} /> <strong>TensorFlow</strong> - Machine learning and AI integration 🤖
              </motion.div>
            </li>
            <li>
              <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }} className="technology-item">
                <SiTypescript size={40} /> <strong>TypeScript</strong> - Scalable and type-safe JavaScript development 🛡️
              </motion.div>
            </li>
            <li>
              <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }} className="technology-item">
                <SiJest size={40} /> <strong>Jest</strong> - Testing framework for reliable applications 🧪
              </motion.div>
            </li>
            <li>
              <motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }} className="technology-item">
                <SiRedux size={40} /> <strong>Redux</strong> - State management for complex applications 🗂️
              </motion.div>
            </li>
          </ul>
        </motion.div>
      </section>

      {/* Fireworks and Particles Animation */}
      <div className="background-particles"></div>
    </div>
  );
};

export default WebDesignPage;